import "./container.css";
import "./EligibilityCriteria.css";

const TickIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
    <path
      d="M10.0623 0.729004L3.64567 7.14567L0.729004 4.229"
      stroke="white"
      strokeWidth="1.45833"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DOCUMENTS_NEEDED = [
  {
    title: "Proof of Identity and Address",
    desc: "Aadhaar card, PAN card, Passport, Voter ID, or Driving License. Both identity and address proof must be valid.",
  },
  {
    title: "Proof of Income",
    desc: "Latest 3 months' salary slips and Form 16 for salaried individuals. ITR and audited financials for self-employed.",
  },
  {
    title: "Bank Statements",
    desc: "Last 6 months' bank statements showing salary credits and transaction history for income verification.",
  },
  {
    title: "Proof of Additional Income",
    desc: "Rental agreements, investment statements, or any other supporting documents if you have additional sources of income.",
  },
];

const ELIGIBILITY_CRITERIA = [
  {
    title: "Salaried Individuals",
    desc: "Employees working with public or private sector companies with regular monthly income and verifiable employment.",
  },
  {
    title: "Self-Employed Professionals",
    desc: "Doctors, chartered accountants, architects, lawyers, and other professionals with stable income sources.",
  },
  {
    title: "Self-Employed Non-Professionals",
    desc: "Business owners, traders, and entrepreneurs with consistent cash flows and business documentation.",
  },
  {
    title: "Age & Citizenship",
    desc: "Applicants must be between 21-65 years of age and should be Indian citizens or NRIs with valid documentation.",
  },
  {
    title: "Credit Score Requirement",
    desc: "A minimum credit score of 650 is preferred. Higher scores may qualify for better interest rates and terms.",
  },
  {
    title: "Minimum Income Requirement",
    desc: "Monthly net income of at least ₹25,000 for salaried and ₹3,00,000 annual turnover for self-employed.",
  },
  {
    title: "Existing Liabilities",
    desc: "Total EMI obligations should not exceed 50% of monthly income. All existing loans must be disclosed.",
  },
];

const CriteriaItem = ({ title, desc }: { title: string; desc: string }) => (
  <div className="eligibility-item">
    <span className="eligibility-tick">
      <TickIcon />
    </span>
    <div>
      <p
        className="eligibility-item-title"
        style={{ color: "#283AAA", fontWeight: 600, fontStyle: "normal", fontFamily: "Inter" }}
      >
        {title}
      </p>
      <p
        className="eligibility-item-desc"
        style={{ color: "#666", fontWeight: 400, fontStyle: "normal", fontFamily: "Inter" }}
      >
        {desc}
      </p>
    </div>
  </div>
);

const EligibilityCriteria = () => {
  return (
    <section className="eligibility-section w-full">
      <div className="container-8xl">
        <h2
          className="eligibility-heading"
          style={{ color: "#000", fontStyle: "normal", fontWeight: 500, fontFamily: "Inter" }}
        >
          Eligibility Criteria For Debt Consolidation Loans
        </h2>
        <p
          className="eligibility-subtext"
          style={{ color: "#666", fontWeight: 400, fontStyle: "normal", fontFamily: "Inter" }}
        >
          Are you eligible for a Debt Consolidation Loan? Check whether you meet the criteria.
        </p>

        <div className="eligibility-card">
          <div className="eligibility-columns">
            <div>
              <h3
                className="eligibility-column-title"
                style={{ fontFamily: "Inter", fontStyle: "normal" }}
              >
                Documents Needed
              </h3>
              {DOCUMENTS_NEEDED.map((item) => (
                <CriteriaItem key={item.title} {...item} />
              ))}

              <div className="eligibility-disclaimer">
                <strong style={{ fontWeight: 700 }}>Disclaimer:</strong> All documents must be
                valid and up-to-date. Digital copies are acceptable for initial review. Original
                documents may be required for verification.
              </div>
            </div>

            <div>
              <h3
                className="eligibility-column-title"
                style={{ fontFamily: "Inter", fontStyle: "normal" }}
              >
                Eligibility Criteria
              </h3>
              {ELIGIBILITY_CRITERIA.map((item) => (
                <CriteriaItem key={item.title} {...item} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EligibilityCriteria;
